import React, { useState, useRef, useEffect } from "react";
import AvatarEditor from "react-avatar-editor";
import Dropzone from "react-dropzone";
import { Text, Button } from "@chakra-ui/react";

export const AvatarUploader = (props) => {
  const { initialImage, editorWidth, editorHeight, editorRadius } = props;

  const [canvasImage, setCanvasImage] = useState(initialImage);

  const [scale, setScale] = useState(1);
  const [sizeError, setSizeError] = useState(false);
  const imageRef = useRef();
  const hiddenFileInput = useRef(null);

  const handleFileButtonClick = () => {
    hiddenFileInput.current.click();
  };

  const handleDrop = (dropped) => {
    if (dropped.length === 0) {
      return;
    }

    if (dropped[0].size / 1000 / 1000 < 5) {
      setSizeError(false);
      setCanvasImage(dropped[0]);
    } else {
      setSizeError(true);
    }
  };

  const handleNewImage = (e) => {
    if (e.target.files.length === 0) {
      return;
    }

    if (e.target.files[0].size / 1000 / 1000 < 5) {
      setSizeError(false);
      setCanvasImage(e.target.files[0]);
    } else {
      setSizeError(true);
    }
  };

  const handleImageChange = async () => {
    const dataURI = imageRef.current.getImage().toDataURL("image/webp", 0.6);
    props.handleImageChange(dataURI);
  };

  const handleScale = (e) => {
    const scale = parseFloat(e.target.value);
    setScale(scale);
  };

  return (
    <div className="flex flex-col gap-2 w-full items-center">
      <Dropzone
        noClick={!!canvasImage}
        onDrop={handleDrop}
        noKeyboard
        accept={{ "image/jpeg": [], "image/png": [], "image/webp": [] }}
      >
        {({ getRootProps, getInputProps, isDragAccept }) => (
          <div className="w-full relative" {...getRootProps()}>
            {canvasImage ? (
              <AvatarEditor
                style={{ margin: "auto" }}
                allowTaint="true"
                ref={imageRef}
                width={editorWidth}
                height={editorHeight}
                borderRadius={editorRadius}
                backgroundColor="gray"
                image={canvasImage}
                onImageReady={handleImageChange}
                onImageChange={handleImageChange}
                border={5}
                scale={scale}
                crossOrigin="anonymous"
              />
            ) : (
              <div
                className={`border border-gray-300 ${isDragAccept ? "bg-green-50" : "bg-gray-100"} transition flex items-center justify-center rounded min-h-[300px]`}
              >
                <p className="text-lg text-center text-gray-500">
                  Drag & drop your image here
                </p>
              </div>
            )}
            <input {...getInputProps()} />
          </div>
        )}
      </Dropzone>

      {sizeError && (
        <div className="w-full flex justify-center py-2">
          <p className="text-red-500">
            Image too large, files must be less than 5MB in size
          </p>
        </div>
      )}
      <Text width="60%" textAlign="center" textStyle="h6">
        - or -
      </Text>

      <Button width="60%" mx="auto" onClick={handleFileButtonClick}>
        Get image from file
      </Button>
      <input
        name="newImage"
        type="file"
        ref={hiddenFileInput}
        style={{ display: "none" }}
        onChange={handleNewImage}
      />
      <div className="w-3/5 flex items-center p-4 justify-between">
        <p className="text-sm w-1/4">Zoom:</p>
        <input
          className="w-full bg-green-55 pl-6"
          name="scale"
          type="range"
          onChange={(e) => handleScale(e)}
          min="0.1"
          max="2"
          step="0.01"
          defaultValue="1"
          color="red"
        />
      </div>
    </div>
  );
};
